import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { NSCommonConstants } from '@ruby/configs/common.constants';
import { ECountryCode } from '@ruby/shared/enums/common.enums';

const isEmptyInputValue = (value: any): boolean => (value || '').trim().length === 0;

export class NSValidators {
  static requiredNotEmpty(control: AbstractControl): ValidationErrors | null {
    // eslint-disable-next-line no-null/no-null
    return isEmptyInputValue(control.value) ? { required: true } : null;
  }

  static phone(isInternational: boolean = false): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.replace(NSCommonConstants.replacePhoneMaskChars, '');

      if (isInternational) {
        // eslint-disable-next-line no-null/no-null
        return !value || (value.length >= 10 && value.length <= 13) ? null : { phone: true };
      } else {
        // eslint-disable-next-line no-null/no-null
        return !value || value.length === 10 ? null : { phone: true };
      }
    };
  }

  static zip(countryCode: ECountryCode | undefined): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      let regex: RegExp = NSCommonConstants.zipPatternByCountryCode.US;

      if (countryCode) {
        regex = NSCommonConstants.zipPatternByCountryCode[countryCode] || NSCommonConstants.zipPatternByCountryCode.US;
      }

      return !control.value || regex.test(control.value) ? {} : { zip: true, countryCode };
    };
  }

  static autocompleteKeyValueValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      let result = {};
      if (typeof control.value === 'string' && control.value !== '') {
        result = { invalidSelection: { value: control.value } };
      }

      return result;
    };
  }

  static requiredArrayValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      if(control.value && control.value.length === 0){
        return { required: true };
      }
      return {};
    };
  }
}
